import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import Select from '../Select/Select'

import screenType from 'component/menuMission/screenType'
import Form from 'component/utils/Form'
import Modal from '../Modal'

const APP_PREFIX = '(App) '
const WEB_PREFIX = '(Web) '

const FIELDS = ['lsCdMenus', 'type']

const EditModal = ({
  appPermissions = [],
  closeModal,
  initialValues,
  lsIdProfilesLength,
  submit,
  translate,
  values,
  values: { type = screenType.ADD_PERMISSIONS },
  webPermissions = [],
}) => {
  const appPermissionsOptions = appPermissions.map((p) => ({
    value: p.cdMenu,
    label: APP_PREFIX + p.dsMenu,
  }))
  const webPermissionsOptions = webPermissions.map((p) => ({
    value: p.cdMenu,
    label: WEB_PREFIX + p.dsMenu,
  }))

  const [selectedAppPermissions, setSelectedAppPermissions] = useState([])
  const [selectedWebPermissions, setSelectedWebPermissions] = useState([])

  useEffect(() => {
    if (
      initialValues.selectedAppPermissions ||
      initialValues.selectedWebPermissions
    ) {
      setSelectedAppPermissions(initialValues.selectedAppPermissions)
      setSelectedWebPermissions(initialValues.selectedWebPermissions)
    }
  }, [])

  const isSubmitDisabled = () =>
    !selectedAppPermissions.length && !selectedWebPermissions.length

  const beforeSubmit = () => {
    const param = {
      ...values,
      lsCdMenus: [...selectedAppPermissions, ...selectedWebPermissions],
    }

    submit(param)
  }

  const portal = { menuPortal: (base) => ({ ...base, zIndex: 9999 }) }

  const scrollToSelect = () => {
    const ele = document.querySelector('.custom-modal-content')
    ele.scrollTop = ele.scrollHeight
  }

  return (
    <Modal
      renderButton={false}
      isOpen
      center={false}
      size='lg'
      title={translate(`missionMenu.updatePermissions.title.${type}`)}
      onConfirm={beforeSubmit}
      onCloseModal={closeModal}
      isConfirmButtonDisabled={isSubmitDisabled()}
      confirmButtonText={translate('save_button_label')}
      cancelButtonText={translate('close_button_label')}
      className='mission-block-edit-modal'
    >
      <em className='left w-100 margin-bottom-double'>
        {translate(`missionMenu.updatePermissions.text1.${type}`)}{' '}
        {lsIdProfilesLength} {translate('missionMenu.updatePermissions.text2')}
      </em>
      <Select
        label={translate('missionMenu.addModal.webPermissions.hint')}
        fill
        required
        isMulti
        menuPlacement='top'
        menuPortalTarget={document.body}
        onChange={(options) =>
          setSelectedWebPermissions(options ? options.map((o) => o.value) : [])
        }
        options={webPermissionsOptions}
        placeholder={translate(
          'missionMenu.addModal.webPermissions.placeholder'
        )}
        styles={portal}
        value={webPermissionsOptions.filter((p) =>
          selectedWebPermissions.some((p2) => p2 === p.value)
        )}
        onDropdownOpen={scrollToSelect}
      />
      <Select
        label={translate('missionMenu.addModal.appPermissions.hint')}
        fill
        required
        isMulti
        menuPlacement='top'
        menuPortalTarget={document.body}
        onChange={(options) =>
          setSelectedAppPermissions(options ? options.map((o) => o.value) : [])
        }
        options={appPermissionsOptions}
        placeholder={translate(
          'missionMenu.addModal.appPermissions.placeholder'
        )}
        styles={portal}
        value={appPermissionsOptions.filter((p) =>
          selectedAppPermissions.some((p2) => p2 === p.value)
        )}
        onDropdownOpen={scrollToSelect}
      />
      <div className='w-100 margin-top-quadruple' />
    </Modal>
  )
}

EditModal.propTypes = {
  appPermissions: PropTypes.array.isRequired,
  closeModal: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  lsIdProfilesLength: PropTypes.number.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  webPermissions: PropTypes.array.isRequired,
}

export default Form({ fields: FIELDS })(EditModal)

export { EditModal }
